import { FC, useRef, useState } from "react";
import {
  UNREAD_POLL_INTERVAL,
  formatBadgeCount,
  useGetUnreadCountQuery,
} from "entities/notification";
import type { NotificationItem } from "entities/notification";
import { useClickOutside } from "shared/model";
import { BellIcon } from "shared/ui";
import { InboxDropdown } from "./InboxDropdown";
import { NewsModal } from "./NewsModal";

import styles from "./NotificationBell.module.css";

interface Props {
  className?: string;
  onOpenTicket?: (ticketId: number) => void;
}

export const NotificationBell: FC<Props> = ({ className, onOpenTicket }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [news, setNews] = useState<NotificationItem | null>(null);
  const rootRef = useRef<HTMLDivElement>(null);
  const { data: unread } = useGetUnreadCountQuery(undefined, {
    pollingInterval: UNREAD_POLL_INTERVAL,
    skipPollingIfUnfocused: true,
  });

  useClickOutside(rootRef, () => setIsOpen(false), isOpen);

  const handleItemClick = (item: NotificationItem) => {
    setIsOpen(false);
    if (item.action?.modal === "news") setNews(item);
    if (item.action?.modal === "ticket") {
      onOpenTicket?.(item.action.data.ticket_id);
    }
  };

  const total = unread?.total ?? 0;

  return (
    <div className={styles.root} ref={rootRef}>
      <button
        type="button"
        className={className}
        title="Notifications"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <BellIcon />
        {total > 0 && (
          <span className={styles.badge}>{formatBadgeCount(total)}</span>
        )}
      </button>

      {isOpen && <InboxDropdown onItemClick={handleItemClick} />}
      {news && <NewsModal news={news} onClose={() => setNews(null)} />}
    </div>
  );
};
